import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { registerServiceWorker } from "./lib/registerServiceWorker";
import { initMonitoring } from "./lib/analytics";

// Initialise Sentry early so it can capture render-time errors.
// No-op when REACT_APP_SENTRY_DSN is not set.
initMonitoring();

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// Enable offline reading in production. No-op on localhost.
registerServiceWorker();
